/** Nível de risco náutico de um evento (compartilhado entre Alertas e Relatórios). */
export type Risk = 'critico' | 'atencao' | 'normal';

const CRITICO = new Set<string>([
  'alarm', // inclui água detectada, SOS, etc.
  'docExpired', // documento vencido
  'insuranceExpired', // seguro vencido
]);

const ATENCAO = new Set<string>([
  'geofenceExit',
  'deviceOverspeed',
  'deviceOffline',
  'deviceUnknown',
  'deviceInactive',
  'maintenance',
  'deviceFuelDrop',
  'rentalOverdue', // retorno de locação atrasado
  'docExpiring', // documento perto do vencimento
  'insuranceExpiring', // seguro perto do vencimento
  'marinaExit', // saída da marina
]);

export function eventRisk(type: string): Risk {
  if (CRITICO.has(type)) return 'critico';
  if (ATENCAO.has(type)) return 'atencao';
  // tipos operacionais (geofenceEnter, ignition*, moving/stopped, online…) = normal
  if (
    type === 'geofenceEnter' ||
    type === 'ignitionOn' ||
    type === 'ignitionOff' ||
    type === 'deviceMoving' ||
    type === 'deviceStopped' ||
    type === 'parking' ||
    type === 'deviceOnline' ||
    type === 'commandResult' ||
    type === 'textMessage'
  ) {
    return 'normal';
  }
  // desconhecidos: tratar como atenção (mais seguro)
  return 'atencao';
}

export const RISK_META: Record<Risk, { label: string; badge: string; chip: string }> = {
  critico: {
    label: 'Crítico',
    badge: 'bg-status-blocked/15 text-status-blocked',
    chip: 'bg-status-blocked/10 text-status-blocked ring-status-blocked/30',
  },
  atencao: {
    label: 'Atenção',
    badge: 'bg-status-ready/15 text-status-ready',
    chip: 'bg-status-ready/10 text-status-ready ring-status-ready/30',
  },
  normal: {
    label: 'Normal',
    badge: 'bg-status-running/15 text-status-running',
    chip: 'bg-status-running/10 text-status-running ring-status-running/30',
  },
};
